export enum CustomerConfirmStatusDetails {
  CustomerPayed = 'customer_payed',
}

export enum CancelStatusDetails {
  CancelledRequisitesTimeout = 'requisites_timeout',
  CancelledSyncRequisitesAttempts = 'sync_requisites_attempts',
}

export enum NewStatusDetails {
  NewStartPaymentSyncAttempt = 'start_payment_sync_attempt',
}
